import React from 'react';
import { useAppSelector } from '../../../contexts/hooks';
import { shallowEqual } from 'react-redux';
import moment from 'moment';

interface OrderInfoProps {
  orderData: any;
}

export const OrderInfo: React.FC<OrderInfoProps> = ({ orderData }) => {
  const dateFormat = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'DateTimeClientFormat')[0]?.Cgn_Resultado, shallowEqual);
  const cmb = useAppSelector((x) => x.configuration.Data?.ComboBox, shallowEqual);
  const systemFields = useAppSelector((x) => x.configuration.Data?.SystemFields, shallowEqual);
  const orderFields = systemFields?.filter((x) => x.Dfc_Tabla === 'Ordenes' && x.Dfc_Estado === true && x.Dfc_Visible).sort((a, b) => a.Dfc_Orden - b.Dfc_Orden);

  const renderValue = (field, value) => {
    if (!value) return '---';

    if (field.TipoCampo.Tcm_Equivalencia === 'dxDateBox') {
      return moment(value).format(dateFormat?.toUpperCase() || 'DD/MM/YYYY');
    }
    if (field.TipoCampo.Tcm_Equivalencia === 'dxSwitch' || field.TipoCampo.Tcm_Equivalencia === 'dxCheckBox') {
      return value === 'true' ? 'SÍ' : 'NO';
    }
    if (field.TipoCampo.Tcm_Equivalencia === 'dxSelectBox' || field.TipoCampo.Tcm_Equivalencia === 'dxLookup') {
      const cmbActual = cmb?.filter((x) => x.Name === field.TablasComboBox?.Tbc_NombreTabla)[0];
      const combo = cmbActual?.Data;
      if (combo && combo.length > 0) {
        const item = combo.find((x) => x[field.TablasComboBox.Tbc_CampoId] === parseInt(value));
        return item ? item[field.TablasComboBox.Tbc_CampoVisible] : value;
      }
    }
    return value;
  };

  if (!orderData) {
    return <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>No hay datos de orden</div>;
  }

  return (
    <div style={{ padding: '15px' }}>
      <div style={{ marginBottom: '10px', paddingBottom: '8px', borderBottom: '2px solid #337ab7' }}>
        <h4 style={{ margin: '0', color: '#337ab7', fontSize: '13px', fontWeight: 'bold' }}>Información de la Orden</h4>
      </div>

      <div style={{ marginBottom: '8px' }}>
        <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px', fontWeight: 'bold' }}>Orden</div>
        <div style={{ fontSize: '12px' }}>{orderData.Ord_Numero || '---'}</div>
      </div>

      {orderFields?.map((field) => {
        const value = field.Dfc_Dinamico && orderData.AditionalFields ? orderData.AditionalFields[field.Dfc_Equivalencia] : orderData[field.Dfc_Equivalencia];

        return (
          <div key={field.Dfc_Id} style={{ marginBottom: '8px' }}>
            <div style={{ fontSize: '11px', color: '#666', marginBottom: '2px', fontWeight: 'bold' }}>{field.Dfc_Label}</div>
            <div style={{ fontSize: '12px' }}>{renderValue(field, value)}</div>
          </div>
        );
      })}
    </div>
  );
};
